<template>
  <div class="chart-container flex justify-center items-center">
    <v-chart
      v-if="!isLoading"
      :options="chartOptions"
      :autoresize="true"
      ref="chart"
      class="rounded-lg border border-gray-200"
    ></v-chart>
    <div v-else class="skeleton-chart">
      <div class="skeleton-bar" v-for="n in 4" :key="n"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GenericBarChart',
  props: {
    data: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    isLoading: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      chartOptions: {
        title: {
          text: this.title,
          left: 'left',
          textStyle: {
            fontSize: 16,
            fontWeight: 'bold',
            color: '#434343',
          },
        },
        xAxis: {
          type: 'value',
          show: false,
          boundaryGap: [0, 0.01],
        },
        yAxis: {
          type: 'category',
          axisLabel: {
            fontSize: 12,
            fontWeight: 'bold',
            color: '#6d6d6d',
            padding: [0, 0, 0, 10],
          },
          axisLine: {
            lineStyle: {
              color: '#6D6D6D',
              width: 0.3,
            },
          },
        },
        series: [
          {
            name: 'Aprovações',
            type: 'bar',
            data: [],
            barWidth: 32,
            itemStyle: {
              color: '#0F4173',
              borderRadius: [10, 10, 10, 10],
              borderColor: '#0F4173',
              borderWidth: 1,
            },
            label: {
              show: true,
              position: 'insideRight',
              color: '#fff',
              fontWeight: 'bold',
              formatter: '{c}',
              align: 'center',
              verticalAlign: 'middle',
              offset: [-20, 0],
            },
          },
        ],
        grid: {
          left: '25%',
          right: '10%',
          bottom: '10%',
          top: '10%',
          containLabel: true,
        },
      },
    };
  },
  watch: {
    data: {
      immediate: true,
      handler(newData) {
        this.updateChart(newData);
      },
    },
  },
  methods: {
    updateChart(data) {
      try {
        this.chartOptions.yAxis.data = data.map((item) => item.week);
        this.chartOptions.series[0].data = data.map(
          (item) => item.approvedProposals,
        );
        if (!this.$refs.chart) {
          console.warn('Chart reference is not available.');
          return;
        }
        this.$refs.chart.setOption(this.chartOptions);
      } catch (error) {
        console.error('Error updating chart:', error);
      }
    },
    resizeChart() {
      if (this.$refs.chart) {
        this.$refs.chart.resize();
      }
    },
  },
  mounted() {
    this.resizeChart();
    window.addEventListener('resize', this.resizeChart);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeChart);
  },
};
</script>

<style scoped>
.chart-container {
  width: 100%;
  height: 100%;
  max-width: 100%;
  max-height: 100%;
  padding: 16px;
}
.skeleton-chart {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  width: 100%;
  height: 100%;
}
.skeleton-bar {
  background-color: #e0e0e0;
  height: 32px;
  border-radius: 5px;
  margin: 8px 0;
  animation: pulse 1.5s infinite;
}
@keyframes pulse {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}
</style>
